import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IPageMeta } from '@ztarmobile/zwp-service';
import { ROUTE_URLS, SUPPORT_ROUTE_URLS } from '../app.routes.names';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CoveragesComponent } from './coverages/coverages.component';
import { DealersComponent } from './dealers/dealers.component';
import { FreeupTalkComponent } from './freeup-talk/freeup-talk.component';
import { HearingAidCompatibilityComponent } from './hearing-aid-compatibility/hearing-aid-compatibility.component';
import { DataSetupComponent } from './data-setup/data-setup.component';
import { InternationalSmsComponent } from './international-sms/international-sms.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { StoreLocatorComponent } from './store-locator/store-locator.component';
import { SupportMainComponent } from './support.component';
import { FaqsComponent } from './faqs/faqs.component';
import { LandingCoverageComponent } from './landing-coverage/landing-coverage.component';
import { SwitchAndSaveComponent } from './switch-and-save/switch-and-save.component';
import { HdVoiceComponent } from './hd-voice/hd-voice.component';
import { WifiCallingPageComponent } from './wifi-calling-page/wifi-calling-page.component';
import { AndroidAttComponent } from './data-setup/android/att/att.component';
import { AndroidFourthGenerationPageComponent } from './data-setup/android/att/fourth-generation-page/fourth-generation-page.component';
import { AndroidFifthGenerationPageComponent } from './data-setup/android/att/fifth-generation-page/fifth-generation-page.component';
import { IosAttComponent } from './data-setup/ios/att/att.component';
import { IosFourthGenerationPageComponent } from './data-setup/ios/att/fourth-generation-page/fourth-generation-page.component';
import { IosFifthGenerationPageComponent } from './data-setup/ios/att/fifth-generation-page/fifth-generation-page.component';
import { HomeComponent } from '../home/home.component';
import { AndroidTmoComponent } from './data-setup/android/tmo/tmo.component';
import { IosTmoComponent } from './data-setup/ios/tmo/tmo.component';

const routes: Routes = [
  {
    path: '', component: SupportMainComponent, children: [
      {
        path: SUPPORT_ROUTE_URLS.CONTACT_US, component: ContactUsComponent,
        data: {
          title: 'Have A Question Or Comment? Contact Us | FreeUp Mobile',
          description: 'Need help? Have a question for our technicians? Contact us here for more help and support.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.COVERAGE, component: CoveragesComponent, data: {
          title: 'Check Wireless Service Coverage Using Our Cell Phone Coverage Map | FreeUp Mobile',
          description: `Check if FreeUp Mobile wireless service has coverage in your area using our cell phone service coverage map. Enter your address or zip code to see
       coverage zones.`} as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.LANDING_COVERAGE, component: LandingCoverageComponent, data: {
          title: '',
          description: ``
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.FREEUP_TALK, redirectTo: `/${ROUTE_URLS.HOME}`, pathMatch: 'full'
      },
      {
        path: SUPPORT_ROUTE_URLS.HEARING_AID_COMPATIBILITY, component: HearingAidCompatibilityComponent, data: {
          title: 'Hearing Aid Compatibility & Support | FreeUp Mobile',
          description: 'Need help with hearing aid compatibility for your phones? Check here for more information about FreeUp Mobile and hearing aid copmatibility.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.DATA_SETUP, component: DataSetupComponent, data: {
          title: 'Activate Data Plans for iPhones & Android Phones | FreeUp Mobile',
          // eslint-disable-next-line max-len
          description: 'Learn how to setup data services for your iPhone or Androind cell phones on the FreeUp Mobile wireless network.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.TMO_IPHONE, component: IosTmoComponent, data: {
          title: 'Data Setup | IPhone',
          description: 'Learn how to setup data services for your iPhone cell phones on the FreeUp Mobile wireless network.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.TMO_Android, component: AndroidTmoComponent, data: {
          title: 'Data Setup | Android',
          description: 'Learn how to setup data services for your Android cell phones on the FreeUp Mobile wireless network.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.ATT_IPHONE, component: IosAttComponent, data: {
          title: 'Data Setup | IPhone',
          description: 'Learn how to setup data services for your iPhone cell phones on the FreeUp Mobile wireless network.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.IPHONE4G, component: IosFourthGenerationPageComponent, data: {
          title: 'Data Setup | IPhone | 4G',
          description: 'Fourth Generation for 4G Iphone Good2go Mobile network.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.IPHONE5G, component: IosFifthGenerationPageComponent, data: {
          title: 'Data Setup | IPhone | 5G',
          description: 'Fifth Generation for 5G Iphone Good2go Mobile network.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.ATT_ANDROID, component: AndroidAttComponent, data: {
          title: 'Data Setup | Android',
          description: 'Learn how to setup data services for your Android cell phones on the FreeUp Mobile wireless network.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.ANDROID4G, component: AndroidFourthGenerationPageComponent, data: {
          title: 'Data Setup | Android | 4G',
          description: 'Fourth Generation for 4G Android FreeUp Mobile network.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.ANDROID5G, component: AndroidFifthGenerationPageComponent, data: {
          title: 'Data Setup | Android | 5G',
          description: 'Fifth Generation for 5G Android FreeUp Mobile network.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.DEALERS, component: DealersComponent, data: {
          title: 'Be An Authorized FreeUp Mobile Dealer | FreeUp Mobile',
          description: 'Interested in partnering with FreeUp Mobile? Start here to become a wireless plan authorized dealer for FreeUp Mobile.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.FAQS, component: FaqsComponent, data: {
          title: 'Freeup Mobile | Support | FAQs',
          description: 'We understand - when small things do not work... you just want an answer. Here are some Frequently Asked Questions.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.SWITCH_AND_SAVE, component: SwitchAndSaveComponent, data: {
          title: 'Switch and Save',
          description: 'Save up to 25% when subscribing to a 3-Month plan. Get 3-month intro offer at our lowest price of $20/mo with unlimited talk and Text and 8GB of high Speed data'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.FAQS_CATEGORY, component: FaqsComponent, data: {
          title: 'Freeup Mobile | Support | FAQs',
          description: 'We understand - when small things do not work... you just want an answer. Here are some Frequently Asked Questions.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.FAQS_QUESTION_ID, component: FaqsComponent, data: {
          title: 'Freeup Mobile | Support | FAQs',
          description: 'We understand - when small things do not work... you just want an answer. Here are some Frequently Asked Questions.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.SHUTDOWN_3G, redirectTo: `/${ROUTE_URLS.HOME}`, pathMatch: 'full'
      },
      {
        path: SUPPORT_ROUTE_URLS.INT_CALLING_TERMS_AND_CONDITIONS,
        loadChildren: () => import('./int-calling-terms-and-conditions/int-calling-terms-and-conditions.module')
          .then(m => m.IntCallingTermsAndConditionsModule),
        data: {
          title: 'International Calling Terms & Conditions | FreeUp Mobile',
          // eslint-disable-next-line max-len
          description: `Please read our terms and conditions carefully. Review terms and conditions for International calling of FreeUp Mobile.`
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.INTERNATIONAL_CALLING, loadChildren: () => import('./international-calling/international-calling.module')
          .then(m => m.InternationalCallingModule)
      },
      {
        path: SUPPORT_ROUTE_URLS.INTERNATIONAL_SMS, component: InternationalSmsComponent, data: {
          title: 'International SMS Country Lisr | FreeUp Mobile',
          description: 'Check the list of countries that is supported for International SMS'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.SITEMAP, component: SitemapComponent, data: {
          title: 'Sitemap | FreeUp Mobile', description:
            `Find FreeUp Mobile sitemap details`
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.STORE_LOCATOR, component: StoreLocatorComponent, data: {
          title: 'Store Locator | FreeUp Mobile',
          description: 'Find FreeUp Mobile authorized retailers near you.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS, loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module')
          .then(m => m.TermsAndConditionsModule)
      },
      {
        path: SUPPORT_ROUTE_URLS.HD_VOICE, component: HdVoiceComponent, data: {
          title: 'FreeUp HD Voice',
          description: 'Enjoy calls that sound like you’re having a conversation with someone in the same room instead of across the country.'
        } as IPageMeta
      },
      {
        path: SUPPORT_ROUTE_URLS.WIFI_CALLING, component: WifiCallingPageComponent, data: {
          title: 'WiFi Calling',
          description: `Make, receive calls over a Wi-Fi network if cellular service isn't available. Enjoy free calls to any number in the US even while traveling internationally.`
        } as IPageMeta
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupportRoutingModule { }
